import { render, staticRenderFns } from "./Achievement.vue?vue&type=template&id=454dbb09&scoped=true&"
import script from "./Achievement.vue?vue&type=script&lang=ts&"
export * from "./Achievement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454dbb09",
  null
  
)

export default component.exports